import { messageBoxSuccess, messageBoxError } from './message-box';
import FormValidation from './form-validation';

class ProductRequest {
  public buttons: NodeListOf<HTMLButtonElement> | null;

  private elScope: HTMLElement | null;
  private el: {
    form: HTMLFormElement | null;
    buttonTabs: NodeListOf<HTMLElement> | null;
    tabColumn: HTMLElement | null;
    inputCompany: HTMLInputElement | null;
  };

  private isLocked = false;
  private formValidation: FormValidation;
  private products: any;

  constructor() {}

  cache() {
    this.buttons = document.querySelectorAll('.js-product-request-btn');
    this.elScope = document.querySelector('#popup-request-product ');

    if(this.elScope) {
      this.el = {
        form: this.elScope.querySelector('form'),
        buttonTabs: this.elScope.querySelectorAll('.js-form-tab-switch'),
        tabColumn: this.elScope.querySelector('[data-key="company"]'),
        inputCompany: this.elScope.querySelector('input[name="company"]'),
      }
    }
  }

  bindings() {
    this.buttons?.forEach((button: HTMLButtonElement) => {
      button.addEventListener('click', (e: Event) => {
        const quickCart = document.querySelector('.js-quick-cart');
        quickCart?.classList.remove('is--active');
        this.appendSelectedProductsToForm(e);
      });
    });

    if(this.el && this.el.buttonTabs) {
      if (this.el.buttonTabs.length > 0) {
        this.el.buttonTabs[0].addEventListener('click', (e) => this.toggleInputCompany(e, false));
        this.el.buttonTabs[1].addEventListener('click', (e) => this.toggleInputCompany(e, true));
      }
    }

    this.formValidation = new FormValidation(
      this.el.form,
      this.handleFormSubmit.bind(this)
    );
    this.formValidation.init();
  }

  private toggleInputCompany(e: MouseEvent, isActive: boolean) {
    const { el } = this;
    const tabColumnNeighbor = el.tabColumn ? el.tabColumn.nextElementSibling : null;
    if(el.buttonTabs && tabColumnNeighbor && el.tabColumn && el.inputCompany) {
      el.buttonTabs.forEach( (buttonTab) => buttonTab.classList.remove('is--active'));
      (e.target as HTMLElement).classList.add('is--active');

      el.inputCompany.value = '';
      if (isActive) {
        el.inputCompany.setAttribute('required', '');
        el.tabColumn.classList.remove('hidden');
        tabColumnNeighbor?.classList.add('col-md-offset-2');
      } else {
        el.inputCompany.removeAttribute('required');
        el.tabColumn.classList.add('hidden');
        tabColumnNeighbor?.classList.remove('col-md-offset-2');
      }
    }
  }

  private async handleFormSubmit() {
    if (this.isLocked) return;
    const formData:FormData = new FormData(this.el.form!);
    const productData = JSON.parse(this.products);

    this.setLock();
    const result = await this.submitData();
    if (result.success) {
      if (result.response && result.response === 'error') {
        //this.setError();
      } else {
        //this.cleanInputs();
        this.elScope?.classList.add('success');

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ lead: null });
        window.dataLayer.push({
          event: 'generate_lead',
          lead: {
            type: 'form_product',
            email: formData.get('email'),
            currency: document.querySelector('.o-product-detail__price > span')?.innerHTML === '€' ? 'EUR' : (document.querySelector('.o-product-detail__price > span')?.innerHTML === 'CHF' ? 'CHF' : 'USD'),
            value: productData[0].price.price.replace('.', '').replace(',', '.'),
            content_type: 'product',
            new_lead: result.hasOwnProperty('is_first_contact') && result.is_first_contact ? 'Yes' : 'No'
          }
        });
      }
    } else {
      //this.setError();
    }
    this.setLock(false);
  }

  protected async submitData(): Promise<{success: boolean, response: any, is_first_contact: boolean}> {
    let success = false;
    let response = 'error';
    let is_first_contact = false;

    const siteHandle = this.el.form?.dataset.site ?? '';
    const apiBaseUrl = document.body.dataset.apiBaseUrl;
    const endpoint = `${apiBaseUrl}api/v1/forms/request_product`;
    this.el.form?.classList.add('loading');

    if(this.el.form) {
      const data = new FormData(this.el.form);

      data.append('products', this.products);

      await fetch(endpoint, {
        method: 'POST',
        body: data,
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.success == true || res.success === 'true') {
            success = true;
            response = 'success';
            is_first_contact = res.is_first_contact ?? false
            this.products = null;
            messageBoxSuccess({
              contentDe: 'E-Mail wurde erfolgreich gesendet.',
              contentEn: 'Successfully sent e-mail.',
            });
          }
        })
        .catch((error) => {
          console.warn(error);
          response = 'error undefined';
          messageBoxError({
            contentDe: 'Es ist ein Fehler aufgetreten. E-Mail konnte nicht gesendet werden.',
            contentEn: 'An error appeared. Could not send e-mail.',
          });
        });
    }

    this.el.form?.classList.remove('loading');
    return { success, response, is_first_contact };
  }

  private setLock(isLocked: boolean = true) {
    this.isLocked = isLocked;
    this.elScope?.classList.toggle('is-sending', this.isLocked);
  }

  appendSelectedProductsToForm(e: Event) {
    const currentTarget = e.currentTarget as HTMLElement | null;
    const customColor: HTMLElement | null = document.querySelector('.js-product-colored-products-color:checked');
    const customColorParent: HTMLElement | null = document.querySelector('.js-product-color-custom-color:checked');
    if (currentTarget && currentTarget.dataset.products) {
      let products = currentTarget.dataset.products as any;
      if (products) {
        products = JSON.parse(products);
        if(!products[0].url) {
          products[0].url = window.location.href;
        }
        if(customColor && customColorParent) {
          products[0].customColor = customColor.dataset.colorName;
        }
        if (products[0].element_id) {
          const popupButton = document.querySelector('#roomle-popup-request-price form button[type="submit"]') as HTMLButtonElement || null;
          if (popupButton) {
            popupButton.dataset.entryId = products[0].element_id;
          }
        }
        products = JSON.stringify(products);
        this.products = products;
      }
    }
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default ProductRequest;
